import { useEffect, useRef, useState } from "react";

const AdContainer = ({ client, slot, style = {}, format = "auto" }) => {
  const adRef = useRef(null);
  const [isAdLoaded, setIsAdLoaded] = useState(null);
  const [adStatus, setAdStatus] = useState(null);
  const hasPushed = useRef(false);


  // useEffect(() => {
  //   if (!adRef.current) return;

  //   const onLoad = () => {
  //     try {
  //       (window.adsbygoogle = window.adsbygoogle || []).push({});
  //       hasPushed.current = true;
  //       // console.log("AdSense pushed on window load");
  //     } catch (error) {
  //       console.error(error);
  //     }
  //   };

  //   window.addEventListener("load", onLoad);

  //   return () => {
  //     window.removeEventListener("load", onLoad);
  //   };
  // }, []);

  // Initialize for localhost or setup observer
  // useEffect(() => {
  //   if (isLocalhost) {
  //     pickRandomCdAd();
  //     setIsAdLoaded(false);
  //     return;
  //   }
  // }, []);


  // Main AdSense loading logic
  // useEffect(() => {
  //   if (typeof window === "undefined" || !adRef.current || hasPushed.current) {
  //     return;
  //   }

  //   const pushTimeout = setTimeout(() => {
  //     if (!adRef.current || hasPushed.current) return;

  //     try {
  //       (window.adsbygoogle = window.adsbygoogle || []).push({});
  //       hasPushed.current = true;
  //       // console.log("AdSense push successful");
  //     } catch (e) {
  //       console.error("AdSense push error:", e);
  //       setIsAdLoaded(false);
  //       return;
  //     }

  //     // Set up mutation observer to watch for data-ad-status changes
  //     const observer = new MutationObserver((mutations) => {
  //       mutations.forEach((mutation) => {
  //         if (
  //           mutation.type === "attributes" &&
  //           (mutation.attributeName === "data-ad-status" ||
  //             mutation.attributeName === "data-adsbygoogle-status")
  //         ) {
  //           const target = mutation.target;
  //           const adStatusValue = target.getAttribute("data-ad-status");
  //           const adsbygoogleStatus = target.getAttribute("data-adsbygoogle-status");

  //           // console.log("Mutation observed:", { adStatusValue, adsbygoogleStatus });
  //           if (adStatusValue) {
  //             setAdStatus(adStatusValue);

  //             if (adStatusValue === "filled") {
  //               setIsAdLoaded(true);
  //             } else if (adStatusValue === "unfilled") {
  //               setIsAdLoaded(false);
  //             }
  //           }
  //         }
  //       });
  //     });

  //     // Observe the ins element for attribute changes
  //     if (adRef.current) {
  //       observer.observe(adRef.current, {
  //         attributes: true,
  //         attributeFilter: ["data-ad-status", "data-adsbygoogle-status"]
  //       });
  //     }

  //     // Fallback check after a delay
  //     const fallbackTimeout = setTimeout(() => {
  //       if (!adRef.current) return;

  //       const currentAdStatus = adRef.current.getAttribute("data-ad-status");
  //       const adsbygoogleStatus = adRef.current.getAttribute("data-adsbygoogle-status");
  //       const hasIframe = adRef.current.querySelector("iframe");
  //       const hasContent = adRef.current.innerHTML?.trim().length > 50;

  //       // console.log("Fallback check:", {
  //       //   currentAdStatus,
  //       //   adsbygoogleStatus,
  //       //   hasIframe: !!hasIframe,
  //       //   hasContent
  //       // });

  //       if (currentAdStatus === "unfilled") {
  //         setIsAdLoaded(false);
  //         setAdStatus("unfilled");
  //       } else if (currentAdStatus === "filled" || (hasIframe && hasContent)) {
  //         setIsAdLoaded(true);
  //         setAdStatus("filled");
  //       } else if (adsbygoogleStatus === "done" && !hasIframe && !hasContent) {
  //         // AdSense finished loading but no ad content - likely unfilled
  //         setIsAdLoaded(false);
  //         setAdStatus("unfilled");
  //       }
  //     }, 3500); // Wait 3.5 seconds for AdSense to fully load

  //     return () => {
  //       observer.disconnect();
  //       clearTimeout(fallbackTimeout);
  //     };
  //   }, 100);

  //   return () => {
  //     clearTimeout(pushTimeout);
  //   };
  // }, []);

  // Render based on ad load state
  if (isAdLoaded === false || isAdLoaded === null) {
    return <></>;
  }

  // console.log("Rendering GoogleAd, isAdLoaded:", isAdLoaded, "adStatus:", adStatus);

  return (
    <>
    </>
    // <div style={{
    //   position: "relative",
    //   minHeight: style.height || "auto" || 100,
    //   marginTop: style.marginTop || 10,
    //   alignSelf: "center",
    // }}>

    //   <ins
    //     className="adsbygoogle"
    //     style={{
    //       display: "block",
    //       // minWidth: "300px",
    //       // minHeight: "50px",
    //       width: "100%",
    //       visibility: isAdLoaded === true ? "visible" : "hidden",
    //       ...style
    //     }}
    //     data-ad-client={client}
    //     data-ad-slot={slot}
    //     data-ad-format={format}
    //     data-full-width-responsive="true"
    //     // data-adtest={isLocalhost ? "on" : "off"}
    //     data-adtest={'on'}
    //     ref={adRef}
    //   ></ins>
    // </div>
  );
};

export default AdContainer;
